// 根据channel来改动

// 首页 生成使用凭证颜色
export const btnBackgroundColor = {
  '': 'linear-gradient(90deg, rgba(255, 48, 48, 1) 0%, rgba(255, 121, 71, 1) 100%)',
  undefined: 'linear-gradient(90deg, rgba(255, 48, 48, 1) 0%, rgba(255, 121, 71, 1) 100%)',
  bankcomm: 'linear-gradient(to right, #ffe4bf, #f2b86d)',
  spdb: '#c6a16f',
  pingan: '#FF4800',
  bcm: 'linear-gradient(90deg, rgba(255, 48, 48, 1) 0%, rgba(255, 121, 71, 1) 100%)',
  bc: 'linear-gradient(128deg, #FFE4BF 0%, #F2B86D 100%)',
  bosc: '#3E5C98',
};

// 字体颜色
export const btnTextColor = {
  '': '#fff',
  undefined: '#fff',
  bankcomm: '#674122',
};

// 使用页面背景颜色
export const usePageBackgroundColor = {
  undefined: '#f34d45',
  bankcomm: '#f2b86d',
  spdb: '#c6a16f',
  pingan: '#1A1F36',
  bosc: '#3E5C98',
};
